module.exports = __webpack_public_path__ + "static/logo-title-ce17a60dca77f6811aba01d247269cd9.svg";